import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF, StringBundle.BTF],
  strings: [
    'DV_RBB_CANCEL_PURCH_MODAL_HEADER',
    'DV_RBB_CANCEL_PURCH_MODAL_SUBMIT',
    'DV_AB_CANCEL_ACCIDENTAL_PURCHASE',
    'DV_DP_you_multiple_orders_for_this_title',
    'DV_DP_choose_order_to_cancel'
  ] as const,
}